define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_profile/validate_phone_verification_simple_form",

        validation: {
            mobile_country: {
                required: true
            },
            mobile_rest: {
                required: true
            },
        }
    });
});
